var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayBardsJumping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 2,
    height: 12,
    rx: 1,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "4; 12; 6; 12; 4",
    dur: "0.8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "10; 4; 8; 4; 10",
    dur: "0.8s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 2,
    height: 16,
    rx: 1,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "8; 16; 10; 16; 8",
    dur: "0.9s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "8; 0; 6; 0; 8",
    dur: "0.9s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 2,
    height: 6,
    rx: 1,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "4; 6; 10; 6; 4",
    dur: "0.7s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "12; 10; 6; 10; 12",
    dur: "0.7s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 2,
    height: 9,
    rx: 1,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "6; 9; 12; 9; 6",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "10; 7; 4; 7; 10",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBardsJumping);
export default __webpack_public_path__ + "static/media/playBardsJumping.4c84b3b4.svg";
export { ForwardRef as ReactComponent };